<template>
  <div v-if="shipments" id="modalInvoice">
    <v-container v-for="(shipment, i) in shipments" :key="i">
      <div>
        <div class="receipt">
          <div class="headerTitle">بوليصة جرد</div>
          <div class="headerSubTitle">رقم البوليصة</div>
          <div id="location">{{ shipment.trackingNumber }}</div>
          <div class="flex">
            <div id="barcodetrack">
              <img
                style="width: 163px;height: 30px;"
                :src='"https://bwipjs-api.metafloor.com/?bcid=code128&text=" + shipment.trackingNumber' />
            </div>
          </div>
          <div id="block_container" style="text-align: right">
            <div id="date" style="display: inline-block; vertical-align: right">
              {{ formateDateWithMoment(new Date(), " YYYY/MM/DD hh:mm A ") }} :
            </div>
            &nbsp;&nbsp;
            <div id="date" style="display: inline-block; vertical-align: right">
              تاريخ الطباعة
            </div>
          </div>
          <div class="keepItBody">------------------------</div>
          <div style="display: flex;">
            <div style="flex: 2 1 50%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">{{ shipment.date | ToDate }} :</h2>
            </div>
            <div style="flex: 20%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">تاريخ الشحن</h2>
            </div>
          </div>
          <div style="display: flex;">
            <div style="flex: 2 1 50%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">{{ shipment.manualNo }} :</h2>
            </div>
            <div style="flex: 20%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">الرقم اليدوي</h2>
            </div>
          </div>
          <div style="display: flex;">
            <div style="flex: 2 1 50%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">{{ shipment.trip.trackingNumber }} :</h2>
            </div>
            <div style="flex: 20%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">رقم الرحلة</h2>
            </div>
          </div>
          <div style="display: flex;">
            <div style="flex: 2 1 50%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">{{ shipment.trip.line.name }} :</h2>
            </div>
            <div style="flex: 20%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">المسار</h2>
            </div>
          </div>
          <div style="display: flex;" v-if="shipment.senderBranch == null">
            <div style="flex: 2 1 50%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">{{
                shipment.senderInfo ? shipment.senderInfo.name
                : "unknown"
              }} :</h2>
            </div>
            <div style="flex: 20%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">المرسل</h2>
            </div>
          </div>
          <div style="display: flex;" v-else>
            <div style="flex: 2 1 50%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">{{
                shipment.senderBranch
                  ? shipment.senderBranch.name : "unknown"
              }} :</h2>
            </div>
            <div style="flex: 20%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">المرسل</h2>
            </div>
          </div>
          <div style="display: flex;" v-if="shipment.receiverBranch == null">
            <div style="flex: 2 1 50%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">{{
                shipment.receiverInfo
                  ? shipment.receiverInfo.name : "unknown"
              }} :</h2>
            </div>
            <div style="flex: 20%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">المستلم</h2>
            </div>
          </div>
          <div style="display: flex;" v-else>
            <div style="flex: 2 1 50%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">{{
                shipment.receiverBranch
                  ? shipment.receiverBranch.name : "unknown"
              }} :</h2>
            </div>
            <div style="flex: 20%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">المستلم</h2>
            </div>
          </div>
          <div style="display: flex;">
            <div style="flex: 2 1 50%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">{{ shipment.receiverInfo.phoneNumber }} :</h2>
            </div>
            <div style="flex: 20%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">جوال المستلم</h2>
            </div>
          </div>
          <div class="keepItBody">------------------------</div>
          <div style="display: flex;">
            <div class="c" style="flex: 2 1 50%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">{{ shipment.notice }} :</h2>
            </div>
            <div style="flex: 20%;">
              <h2 id="date" style="text-align: right; font-weight: bold;">الملاحظات</h2>
            </div>
          </div>
          <div id="bot">
            <div id="table">
              <table>
                <tr class="tabletitle">
                  <td class="Rate" style="font-size: x-large">
                    <h2>السعر</h2>
                  </td>
                  <td class="Hours" style="font-size: x-large">
                    <h2>العدد</h2>
                  </td>
                  <td class="item" style="font-size: x-large">
                    <h2>الصنف</h2>
                  </td>
                </tr>
                <tr class="service" v-for="(item, index) in shipment.items" :key="index">
                  <td class="tableitem">
                    <div id="block_container" style="text-align: center">
                      <div style="display: inline-block; vertical-align: middle">
                        <p class="itemtext" style="text-align: center; padding-right: 5px">
                          <svg
                            class="riyal-svg"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1124.14 1256.39"
                            width="12"
                            height="13"
                            style="display:inline-block;vertical-align:-0.125em;">
                            <path
                              fill="currentColor"
                              d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z" />
                            <path
                              fill="currentColor"
                              d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z" />
                          </svg>
                        </p>
                      </div>
                      <div style="display: inline-block; vertical-align: middle">
                        <p class="itemtext" style="text-align: center; font-weight: bold">
                          {{ round(item.price) }}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td class="tableitem">
                    <p class="itemtext" style="text-align: center; font-weight: bold">
                      <span v-if="shipment.items && shipment.items.length >= 1">
                        {{ item.quantity }}
                      </span>
                    </p>
                  </td>
                  <td class="tableitem">
                    <p class="itemtext" style="padding-right: 2px; font-weight: bold">
                      <span v-if="shipment.items && shipment.items.length >= 1">{{
                        item.merchandise.name
                      }}</span>
                    </p>
                  </td>
                </tr>
              </table>
            </div>
            <!--End Table-->
          </div>
          <div class="keepItBody">------------------------</div>
        </div>
      </div>
      <div class="pagebreak" />
    </v-container>
  </div>
</template>

<script>
import TripsService from "../../LandShipping/services/TripsService";

export default {
  mounted() {
    const id = +this.$route.query.tripId;
    if (id) this.getDataFromAPI(id);
    else this.getDataFromStore();
  },
  data() {
    return {
      trip: {},
      shipments: [],
      printData: null,
      barcodetracking: null,
    };
  },
  methods: {
    getDataFromAPI(id) {
      TripsService.print(id).then((resp) => {
        this.printData = {};
        this.trip = resp.data.trip;
        this.shipments = resp.data.shipments;

        setTimeout(() => {
          const options = {
            styles: [
              "https://2025.rasil.com.sa/Data/Images/ExternalShippers/style.css",
            ],
            timeout: 1000,
            autoClose: true,
            windowTitle: window.document.title,
          };
          this.$htmlToPaper("modalInvoice", options);
        }, 100);
      })
        .catch((resp) => { })
        .finally(() => { });
    },
    getDataFromStore() {
      this.printData = this.$store.getters.printData;
      this.trip = this.printData.trip;
      this.shipments = this.printData.shipments;
    },
  },
};
</script>

<style lang="css" scoped>
body {
  font-family: 'Roboto', sans-serif;
  margin: 0px;
  padding: 0px;
}

::selection {
  background: #f31544;
  color: #FFF;
}

::moz-selection {
  background: #f31544;
  color: #FFF;
}

h1 {
  font-size: 1.5em;
  color: #222;
}

h2 {
  font-size: .9em;
  text-align: center;
}

h3 {
  font-size: 1.2em;
  font-weight: 300;
  line-height: 2em;
}

p {
  font-size: .7em;
  color: #666;
  line-height: 1.2em;
}

#top,
#mid,
#bot {
  /* Targets all id with 'col-' */
  border-bottom: 1px solid #EEE;
}

#top {
  min-height: 100px;
}

#mid {
  min-height: 80px;
}

#bot {
  min-height: 50px;
}

#top .logo {
  height: 60px;
  width: 60px;
  background: url(http://michaeltruong.ca/images/logo1.png) no-repeat;
  background-size: 60px 60px;
}

.clientlogo {
  float: left;
  height: 60px;
  width: 60px;
  background: url(http://michaeltruong.ca/images/client.jpg) no-repeat;
  background-size: 60px 60px;
  border-radius: 50px;
}

.info {
  display: block;
  margin-left: 0;
}

.title {
  float: right;
}

.title p {
  text-align: right;
}

table {
  width: 100%;
  border-collapse: collapse;
  border: black solid 1px;
}

.tabletitle {
  font-size: .5em;
  background: #EEE;
}

.service {
  border-bottom: 1px solid #EEE;
}

.item {
  width: 24mm;
}

.itemtext {
  font-size: 15px;
  text-align: end;
}

#legalcopy {
  margin-top: 5mm;
}

.receipt {
  width: 48mm;
  padding-left: 18px;
  padding-right: 25px;
}

.orderNo {
  width: 100%;
  text-align: right;
  padding-bottom: 1mm;
  font-size: 8pt;
  font-weight: bold;
}

td,
th {
  border: black solid 1px;
  padding: 1px 2px 1px 2px;
}

.orderNo:empty {
  display: none;
}

.headerSubTitle {
  font-family: 'Equestria', 'Permanent Marker', cursive;
  text-align: center;
  font-size: 12pt;
}

.headerTitle {
  font-family: 'Equestria', 'Permanent Marker', cursive;
  text-align: center;
  font-size: 40pt;
  font-weight: bold;
}

#location {
  margin-top: 5pt;
  text-align: center;
  font-size: 16pt;
  font-weight: bold;
}

#date {
  margin: 5pt 0px;
  text-align: center;
  font-size: 8pt;
}

#barcode {
  display: block;
  margin: 0px auto;
}

#barcode:empty {
  display: none;
}

.watermark {
  position: absolute;
  left: 7mm;
  top: 60mm;
  width: 75mm;
  opacity: 0.1;
}

.keepIt {
  text-align: center;
  font-size: 12pt;
  font-weight: bold;
  padding-top: 7px;
  padding-bottom: 7px;
}

.keepItBody {
  text-align: center;
  font-size: 8pt;
}

.item {
  margin-bottom: 1mm;
}

.itemRow {
  display: flex;
  font-size: 8pt;
  align-items: baseline;
}

.itemRow>div {
  align-items: baseline;
}

.itemName {
  font-weight: bold;
}

.itemPrice {
  text-align: right;
  flex-grow: 1;
}

.itemColor {
  width: 10px;
  height: 100%;
  background: yellow;
  margin: 0px 2px;
  padding: 0px;
}

.itemColor:before {
  content: "\00a0";
}

.itemData2 {
  text-align: right;
  flex-grow: 1;
}

.itemData3 {
  width: 15mm;
  text-align: right;
}

.itemQuantity:before {
  content: "x";
}

.itemTaxable:after {
  content: " T";
}

.flex {
  display: flex;
  justify-content: center;
}

#qrcode {
  align-self: center;
  flex: 0 0 100px
}

.totals {
  flex-grow: 1;
  align-self: center;
  font-size: 8pt;
}

.totals .row {
  display: flex;
  text-align: right;
}

.totals .section {
  padding-top: 2mm;
}

.totalRow>div,
.total>div {
  text-align: right;
  align-items: baseline;
  font-size: 8pt;
}

.totals .col1 {
  text-align: right;
  flex-grow: 1;
}

.totals .col2 {
  width: 22mm;
}

.totals .col2:empty {
  display: none;
}

.totals .col3 {
  width: 15mm;
}

.footer {
  overflow: hidden;
  margin-top: 5mm;
  border-radius: 7px;
  width: 100%;
  background: black;
  color: white;
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
}

.footer:empty {
  display: none;
}

.eta {
  padding: 1mm 0px;
}

.eta:empty {
  display: none;
}

.eta:before {
  content: "Estimated time order will be ready: ";
  font-size: 8pt;
  display: block;
}

.etaLabel {
  font-size: 8pt;
}

.printType {
  padding: 1mm 0px;
  width: 100%;
  background: grey;
  color: white;
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
}

.about {
  font-size: 12pt;
  overflow: hidden;
  background: #FCEC52;
  color: #3A5743;
  border-radius: 7px;
  padding: 0px;
  position: absolute;
  width: 500px;
  text-align: center;
  left: 50%;
  margin-top: 50px;
  margin-left: -250px;
}

.arrow_box h3,
ul {
  margin: 5px;
}

.about li {
  text-align: left;
}

.arrow_box {
  position: absolute;
  background: #88b7d5;
  padding: 5px;
  margin-top: 20px;
  left: 95mm;
  top: 2;
  width: 500px;
  border: 4px solid #c2e1f5;
}

.arrow_box:after,
.arrow_box:before {
  right: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.arrow_box:after {
  border-color: rgba(136, 183, 213, 0);
  border-right-color: #88b7d5;
  border-width: 30px;
  margin-top: -30px;
}

.arrow_box:before {
  border-color: rgba(194, 225, 245, 0);
  border-right-color: #c2e1f5;
  border-width: 36px;
  margin-top: -36px;
}
</style>
